<template>
    <div id='tecnology-template'>
        <!-- 查询form -->
        <el-card class="table_searchbar">
            <el-row style="margin-bottom: 20px;">
                <el-col :span="W?5:5">
                    <div>
                        <span class="title">模板名称：</span>
                        <el-input :style="W?{'max-width':'160px'}:{'max-width':'95px'}" size="small" v-model="searchForm.technologyTemplateName" maxlength="100" placeholder="模板名称"></el-input>
                    </div>
                </el-col>
                <el-col :span="W?5:5">
                    <div>
                        <span class="title">模板编码：</span>
                        <el-input :style="W?{'max-width':'160px'}:{'max-width':'95px'}" size="small" v-model="searchForm.technologyTemplateCode" maxlength="100" placeholder="模板编码"></el-input>
                    </div>
                </el-col>
                <el-col :span="W?10:10">
                    <div>
                        <span class="title">创建时间：</span>
                        
                        <el-date-picker style="width: 340px;" v-model="searchForm.gmtCreate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                    </div>
                </el-col>
                <el-col :span="W?4:4" style="text-align:right">
                    <el-button icon="el-icon-search" size="mini" type="primary" @click="clickSearch">查询</el-button>
                    <el-button style="margin-left: 9px;" icon="el-icon-refresh" size="mini" @click="resetSearch">重置</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-card class="table-card">
            <div class="table_common_operbar ">
            <el-row>
                <el-button  size="small" type="primary" @click="showAdd" v-if="permission.btn_technologyTemplate_add">新增模板</el-button>
            </el-row>
        </div>
            <!-- table开始 -->
            <el-row class="tab" style="margin-top:30px">
                <el-table :data="tableList" style="width: 100%">
                    <el-table-column show-overflow-tooltip prop="technologyTemplateName" label="模板名称"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="technologyTemplateCode" label="模板编码"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" label="工艺路线描述"></el-table-column>
                    <!-- <el-table-column show-overflow-tooltip prop="materialType" label="物料类型"></el-table-column> -->
                    <el-table-column show-overflow-tooltip prop="gmtCreate" label="创建时间"></el-table-column>
                    <el-table-column show-overflow-tooltip label="操作" fixed="right" width="160">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="seeDetail(scope.row)" v-if="permission.btn_technologyTemplate_add">查看</el-button>
                            <el-button type="text" size="small" @click="editTemplate(scope.row)" v-if="permission.btn_technologyTemplate_update">编辑</el-button>
                            <el-button class="btn-del" type="text" size="small" @click="deleteList(scope.row)" v-if="permission.btn_technologyTemplate_update">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
            <!-- table结束 -->

            <!-- 分页开始 -->
            <div class="page" style="margin-right:20px;float:right;margin-top:20px">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size.sync="page.pageSize" layout="total, prev, pager, next, jumper" :total="page.total">
                </el-pagination>
            </div>
            <!-- 分页结束 -->
        </el-card>

        <!-- 新增模板开始 -->
        <el-dialog title="新增工艺路线模板" :visible.sync="addDialogVisible" center width="70%">
            <el-form label-width="100px" class="demo-ruleForm" :model="addTemplateForm" :rules="rules" ref="addForm">
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="模板名称:" prop="technologyTemplateName" :rules="rules.technologyTemplateName">
                            <el-input maxlength="32" :style="W?{'max-width':'320px'}:{'max-width':'260px'}" v-model.trim="addTemplateForm.technologyTemplateName"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="10">
                        <el-form-item label="模板编码:" prop="technologyTemplateCode" :rules="rules.technologyTemplateCode">
                            <el-input maxlength="32" :style="W?{'max-width':'160px'}:{'max-width':'100px'}"  v-model.trim="addTemplateForm.technologyTemplateCode"></el-input>
                        </el-form-item>
                    </el-col> -->
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="工艺线路描述:" prop="remark">
                            <el-input maxlength="200"  v-model="addTemplateForm.remark" type="textarea" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            
                <el-table :data="addTemplateForm.templateFlowVOs"  class="technolog-template-table">
                    <el-table-column label="操作" width="80">
                        <template slot-scope="scope">
                            <el-form-item  style="display: inline-block;">
                                <i class="el-icon-delete" v-if="addTemplateForm.templateFlowVOs.length>1" style="color:red;cursor:pointer;font-size:16px;" @click="delLists(scope.$index)"></i>
                                <i @click="addLists(scope.$index)" class="el-icon-circle-plus-outline" v-if="scope.$index+1==addTemplateForm.templateFlowVOs.length" style="color:#007ACC;cursor:pointer;font-size:16px;font-weight:700"></i>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="序号" min-width='50'>
                        <template slot-scope="scope">
                            <el-form-item  :prop="`templateFlowVOs[${scope.$index}].procedureIndex`"  :rules="rules.procedureIndex">
                                <el-input maxlength="8" v-model.trim="scope.row.procedureIndex" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工序编码" min-width="120px">
                        <template slot-scope="scope">
                            <el-form-item  style="display: inline-block;">
                                <el-select v-model="scope.row.procedureCode" @visible-change="($event)=>{if(!$event){loadProcedureListByProcedure('','',scope.row)}}" @change="procedureSelectChange($event,scope.row)"  filterable  clearable :loading="loading" remote :remote-method="query=>loadProcedureListByProcedure(query,'',scope.row)">
                                    <el-option v-for="(item,index) in (scope.row.procedureMapFactoryModelList)" :key="index" :label="item.procedureCode" :value="item.procedureCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工序名称" min-width='120'>
                        <template slot-scope="scope">
                            <el-form-item :prop="`templateFlowVOs[${scope.$index}].procedureName`" :rules="rules.procedureName">
                                <el-select v-model="scope.row.procedureName"  @visible-change="($event)=>{if(!$event){loadProcedureListByProcedure('','',scope.row)}}" @change="procedureSelectChange($event,scope.row)" filterable  clearable :loading="loading" remote :remote-method="query=>loadProcedureListByProcedure('',query,scope.row)">
                                    <el-option v-for="(item,index) in (scope.row.procedureMapFactoryModelList)" :key="index" :label="item.procedureName" :value="item.procedureCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工作中心编码" min-width='120'>
                        <template slot-scope="scope">
                            <el-form-item :prop="`templateFlowVOs[${scope.$index}].factoryModelId`"  style="margin-left:0">
                                <!-- <el-select v-model="scope.row.factoryModelId"  filterable @change="factoryChange($event,scope)">
                                    <el-option v-for="item in FactoryList" :key="item.factoryId" :label="item.factoryCode" :value="item.factoryId"></el-option>
                                </el-select> -->
                                <el-input disabled  v-model="scope.row.factoryModelCode" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column label="工作中心名称" min-width='120'>
                        <template slot-scope="scope">
                            <el-form-item :prop="`templateFlowVOs[${scope.$index}].factoryModelId`"  >
                                <!-- <el-select v-model="scope.row.factoryModelId"  filterable @change="factoryChange($event,scope)">
                                    <el-option v-for="item in FactoryList" :key="item.factoryId" :label="item.factoryName" :value="item.factoryId"></el-option>
                                </el-select> -->
                                <el-input disabled  v-model="scope.row.factoryModelCode" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    
                   
                    <!-- <el-table-column label="工序说明" min-width='120'>
                        <template slot-scope="scope">
                            <el-form-item >
                                <el-input maxlength="32" v-model="scope.row.templateFlowRemark"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column> -->

                    <el-table-column label="默认工价(元)" min-width='50'>
                        <template slot-scope="scope">
                            <el-form-item :prop="`templateFlowVOs[${scope.$index}].defaultSalary`" :rules="rules.defaultSalary">
                                <el-input maxlength="8" v-model.trim="scope.row.defaultSalary"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="是否报工" min-width='60'>
                        <template slot-scope="scope">
                            <el-form-item >
                                <el-checkbox v-model="scope.row.isNeedReport"></el-checkbox>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="是否追溯扫码" min-width='60'>
                        <template slot-scope="scope">
                            <el-form-item >
                                <el-checkbox v-model="scope.row.needScanCode"></el-checkbox>
                            </el-form-item>
                        </template>
                    </el-table-column> -->
                </el-table>
            </el-form>
            <!-- 工艺明细结束 -->
            <span slot="footer">
                <el-button type="primary" @click="addFFactory">确 定</el-button>
                <el-button @click="cancelAdd">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 新增模板结束 -->

        <!-- edit -->
        <el-dialog title="编辑工艺路线模板" :visible.sync="editDialogVisible" center width="70%">
            <el-form label-width="100px" class="demo-ruleForm" :model="addTemplateForm" :rules="rules" ref="editForm">
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="模板名称:" prop="technologyTemplateName" :rules="rules.technologyTemplateName">
                            <el-input maxlength="32" :style="W?{'max-width':'160px'}:{'max-width':'100px'}" v-model.trim="addTemplateForm.technologyTemplateName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="模板编码:" prop="technologyTemplateCode" >
                            <el-input maxlength="32" disabled :style="W?{'max-width':'160px'}:{'max-width':'100px'}"  v-model.trim="addTemplateForm.technologyTemplateCode"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="工艺线路描述:" prop="remark">
                            <el-input maxlength="200"  v-model="addTemplateForm.remark" type="textarea" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            
                <el-table :data="addTemplateForm.templateFlowVOs"  class="technolog-template-table">
                    <el-table-column label="操作" width="80">
                        <template slot-scope="scope">
                            <el-form-item  style="display: inline-block;">
                                <i class="el-icon-delete" v-if="addTemplateForm.templateFlowVOs.length>1" style="color:red;cursor:pointer;font-size:16px;" @click="delLists(scope.$index)"></i>
                                <i @click="addLists(scope.$index)" class="el-icon-circle-plus-outline" v-if="scope.$index+1==addTemplateForm.templateFlowVOs.length" style="color:#007ACC;cursor:pointer;font-size:16px;font-weight:700"></i>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="序号" min-width='50'>
                        <template slot-scope="scope">
                            <el-form-item  :prop="`templateFlowVOs[${scope.$index}].procedureIndex`" :rules="rules.procedureIndex">
                                <el-input maxlength="8" v-model.trim="scope.row.procedureIndex" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工序编码" min-width="120px">
                        <template slot-scope="scope">
                            <el-form-item  style="display: inline-block;">
                                <el-select v-model="scope.row.procedureCode" @visible-change="($event)=>{if(!$event){loadProcedureListByProcedure('','',scope.row)}}" @change="procedureSelectChange($event,scope.row)"  filterable  clearable :loading="loading" remote :remote-method="query=>loadProcedureListByProcedure(query,'',scope.row)">
                                    <el-option v-for="(item,index) in (scope.row.procedureMapFactoryModelList||procedureMapFactoryModelList)" :key="index" :label="item.procedureCode" :value="item.procedureCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工序名称" min-width='120'>
                        <template slot-scope="scope">
                            <el-form-item :prop="`templateFlowVOs[${scope.$index}].procedureName`" :rules="rules.procedureName">
                                <el-select v-model="scope.row.procedureName"  @visible-change="($event)=>{if(!$event){loadProcedureListByProcedure('','',scope.row)}}" @change="procedureSelectChange($event,scope.row)" filterable  clearable :loading="loading" remote :remote-method="query=>loadProcedureListByProcedure('',query,scope.row)">
                                    <el-option v-for="(item,index) in (scope.row.procedureMapFactoryModelList||[])" :key="index" :label="item.procedureName" :value="item.procedureCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="工作中心编码" min-width='120'>
                        <template slot-scope="scope">
                            <el-form-item :prop="`templateFlowVOs[${scope.$index}].factoryModelId`"  style="margin-left:0">
                                <!-- <el-select v-model="scope.row.factoryModelId"  filterable @change="factoryChange($event,scope)">
                                    <el-option v-for="item in FactoryList" :key="item.factoryId" :label="item.factoryCode" :value="item.factoryId"></el-option>
                                </el-select> -->
                                <el-input disabled  v-model="scope.row.factoryModelCode" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>

                    <el-table-column label="工作中心名称" min-width='120'>
                        <template slot-scope="scope">
                            <el-form-item :prop="`templateFlowVOs[${scope.$index}].factoryModelId`"  >
                                <!-- <el-select v-model="scope.row.factoryModelId"  filterable @change="factoryChange($event,scope)">
                                    <el-option v-for="item in FactoryList" :key="item.factoryId" :label="item.factoryName" :value="item.factoryId"></el-option>
                                </el-select> -->
                                <el-input disabled  v-model="scope.row.factoryModelCode" ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    
                   
                    <!-- <el-table-column label="工序说明" min-width='120'>
                        <template slot-scope="scope">
                            <el-form-item >
                                <el-input maxlength="32" v-model="scope.row.templateFlowRemark"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column> -->

                    <el-table-column label="默认工价(元)" min-width='50'>
                        <template slot-scope="scope">
                            <el-form-item :prop="`templateFlowVOs[${scope.$index}].defaultSalary`" :rules="rules.defaultSalary">
                                <el-input maxlength="8" v-model.trim="scope.row.defaultSalary"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="是否报工" min-width='60'>
                        <template slot-scope="scope">
                            <el-form-item >
                                <el-checkbox v-model="scope.row.isNeedReport"></el-checkbox>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="是否追溯扫码" min-width='60'>
                        <template slot-scope="scope">
                            <el-form-item >
                                <el-checkbox v-model="scope.row.needScanCode"></el-checkbox>
                            </el-form-item>
                        </template>
                    </el-table-column> -->
                </el-table>
            </el-form>
            <!-- 工艺明细结束 -->
            <span slot="footer">
                <el-button type="primary" @click="editSubmitList">确 定</el-button>
                <el-button @click="cancelEdit">取 消</el-button>
            </span>
        </el-dialog>
        <!-- edit -->

        <!-- see -->
        <el-dialog title="查看工艺路线模板" :visible.sync="seedDialogVisible" center width="60%">
            <el-form label-width="100px" class="demo-ruleForm">
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="模板名称:" prop="name">
                            <el-input disabled :style="W?{'max-width':'160px'}:{'max-width':'100px'}" v-model="seeData.technologyTemplateName"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="模板编码:" prop="code">
                            <el-input disabled :style="W?{'max-width':'160px'}:{'max-width':'100px'}"  v-model="seeData.technologyTemplateCode"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="工艺线路描述:" prop="remark">
                            <el-input disabled :style="W?{'max-width':'545px'}:{'width':'360px'}" v-model="seeData.remark"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <el-table :data="seeItemList" style="width: 100%">
                <el-table-column prop="procedureIndex" label="序号" min-width="50px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="procedureCode" label="工序编码" min-width="80px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="procedureName" label="工序名称" min-width="80px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="factoryModelCode" label="工作中心编码" min-width="100px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="factoryModelName" label="工作中心名称" min-width="100px" show-overflow-tooltip></el-table-column>
                
                <!-- <el-table-column prop="templateFlowRemark" label="工序说明" min-width="80px" show-overflow-tooltip></el-table-column> -->
                <el-table-column prop="defaultSalary" label="默认工价" min-width="80px" show-overflow-tooltip></el-table-column>
                <el-table-column label="是否报工" min-width="80px">
                    <template slot-scope="scope">
                        <span>
                            <el-checkbox label="" disabled v-model="scope.row.isNeedReport"></el-checkbox>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 工艺明细结束 -->
            <span slot="footer">
                <el-button type="primary" @click="seedDialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- see -->
    </div>
</template>

<script>
export default {
    name:'TechnologyTemplate',
    data() {
        return {
            // 分页
            page: {
                total: 0,
                pageSize: 10,
                pageNum: 1,
                currentPage: 1
            },
            // 查看
            seedDialogVisible: false,
            seeItemList: [],
            // 查看数据
            seeData: {},
            // 新增
            addDialogVisible: false,
            // 编辑
            editDialogVisible: false,
            // 编辑数据
            editItemList: [],
            // 编辑数据
            editData: {},
            W: "",
            searchForm: {
                //   模板名称
                technologyTemplateName:'',
                technologyTemplateCode:'',
                gmtCreate: [],

            },
            loading:false,
            FactoryForm: {
                //   模板名称
                TemplateName: "",
                public: "",
                factoryPublic: ''
            },
            // 新增表单
            addTemplateForm: {
                technologyTemplateName: '',
                technologyTemplateCode: '',
                remark: '',
                templateFlowVOs:[{
                    procedureIndex:1,
                    isNeedReport:true
                }],
            },
            procedureNameList:[],
            rules:{
                technologyTemplateName: [
                    { required: true, message: '请输入模板名称', trigger: 'blur' }
                ],
                // technologyTemplateCode: [
                //     { required: true, message: '请输入模板编码', trigger: 'blur' }
                // ],
                
                factoryModelId:[
                    { required: true, message: '请选择工作中心', trigger: 'blur' },
                    // {
                    //     validator(rule, value, callback) {
                    //        log(value,555)
                    //     }, trigger: 'blur'
                    // }
                ],
                procedureIndex:[
                    { required: true, message: '工序号不能为空', trigger: 'blur' },
                    {
                        validator(rule, value, callback) {
                            if(value){
                                let reg = /^([1-9]{1}\d*)$/
                                if(!reg.test(value)){
                                    callback(new Error('工序号必须为正整数'))
                                }else{
                                    
                                    callback() 
                                    
                                }
                            }else{
                                callback('工序号不能为空')
                            }
                        }, trigger: 'blur'
                    }
                ],
                procedureName: [
                    { required: true, message: '请输入工序名称', trigger: 'blur' }
                ],
                defaultSalary:[
                    {
                        validator(rule, value, callback) {
                            if(value){
                                let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/
                                if(!reg.test(value)){
                                    callback(new Error(`工价大于零且最多可保留4位小数`))
                                }else{
                                    callback() 
                                }
                            }else{
                                callback()
                            }
                        }, trigger: 'blur'
                    }
                ]
            },
            //   远程搜索下拉列表
            materiaList: [],
            // 工作中心下拉框
            FactoryList: [],
            searchFactoryList: {},
            // 页面列表
            tableList: [],
            //   明细列表
            detailedList: [
                {
                    id: 10,
                    nextProcedure: 20
                },
                {
                    id: 20,
                    nextProcedure: ""
                }
            ],

            procedureMapFactoryModelList:[],

            // 
            templateFlowVOs: [{ procedureIndex: 1 ,isNeedReport:true}],
            // 
            optionsList: [
                { id: 0, name: "事件一" },
                { id: 1, name: "事件二" }
            ],
            // flag:true,
            // flag1:true,
            permission: JSON.parse(localStorage.getItem("permission"))
        };
    },
    created: function () {
        this.getMlist();
        this.getListFactoryModel()
        this.search()
    },
    mounted: async function () {
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? (this.W = true) : (this.W = false);
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? (this.W = true) : (this.W = false);
        };
        this.procedureMapFactoryModelList = await this.loadProcedureListByProcedure()
        // this.init();
    },
    methods: {
        async loadProcedureListByProcedure(procedureCode,procedureName,row){
            this.loading = true
            let {data,code,message,msg} = await this.$RequestUtil.getAsync({url: "/api/factoryModel/listByProcedureCode",params: {procedureCode,procedureName}})
            if(row){
                this.$set(row,'procedureMapFactoryModelList',data)
                console.log(row)
            }
            this.loading =false
            return data
        },

        showAdd(){
            this.addDialogVisible=true
            // this.addTemplateForm.templateFlowVOs[0].procedureMapFactoryModelList = commonUtils.cloneObj(this.procedureMapFactoryModelList)
            this.$set(this.addTemplateForm.templateFlowVOs[0],'procedureMapFactoryModelList',commonUtils.cloneObj(this.procedureMapFactoryModelList))
        },

        procedureSelectChange(ev,row){
            let findItem = row.procedureMapFactoryModelList.find(item=>item.procedureCode==ev)||{}
            this.$set(row,'procedureName',findItem.procedureName)
            this.$set(row,'procedureCode',ev)
            this.$set(row,'factoryModelCode',findItem.factoryModelCode)
            this.$set(row,'factoryModelName',findItem.factoryModelName)
        },


        reload() {
            this.search()
           this.getListFactoryModel()
            this.$store.commit('delete_reloadPages','/TechnologyBOM/TechnologyTemplate')
        },
        // 页/条
        handleSizeChange(pageSize) {
            log(pageSize)
            this.page.pageSize = pageSize
            this.search()
        },
        // 当前页current-page
        handleCurrentChange(pageNum) {
            log(pageNum)
            this.page.pageNum = pageNum
            this.search(pageNum)
        },
        clickSearch() {
            this.search()
        },
        // 搜索
        search: function (pageNum) {
            if (pageNum == null || pageNum instanceof KeyboardEvent) {
                pageNum = 1;
            }
            let gmtCreateStart = null
            let gmtCreateEnd = null
            if(this.searchForm.gmtCreate.length==2 ){
                gmtCreateStart = this.searchForm.gmtCreate[0]
                gmtCreateEnd = this.searchForm.gmtCreate[1]
            }
            this.$set(this.page, "pageNum", pageNum);
            this.$RequestUtil.get({
                url: "/api/technologyTemplate/listTemplateMsg",
                type: "sync",
                params: {
                    // 当前页
                    pageNum: pageNum,
                    // 页/条
                    pageSize: this.page.pageSize,
                    // 模板编码ApiModelProperty
                    technologyTemplateCode: this.searchForm.technologyTemplateCode,
                    // 模板名称ApiModelProperty
                    technologyTemplateName: this.searchForm.technologyTemplateName,
                    // 创建时间ApiModelProperty
                    gmtCreateStart,
                    gmtCreateEnd
                },
                success: res => {
                    if (res.code == 0) {
                        log(res);
                        this.tableList = res.data;
                        log(this.tableList)
                        this.page.total = res.totalPages;
                        if (res.totalPages == 0) {
                            this.$message.warning("查询不到符合条件的数据");
                        }
                    } else {
                        this.$message.error(res.message || res.msg);
                    }
                }
            });
        },
       
        // 添加工艺明细
        addFFactory() {
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    let procedureIndexList = [...new Set(this.addTemplateForm.templateFlowVOs.map(item=>Number(item.procedureIndex)))]
                    if(procedureIndexList.length<this.addTemplateForm.templateFlowVOs.length){
                        this.$message.error('工序号不可重复')
                        return
                    }
                    this.$RequestUtil.post({
                        url: '/api/technologyTemplate/addTemplate',
                        type: 'sync',
                        params: {
                        ...this.addTemplateForm
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message.success('添加成功')
                                this.addDialogVisible = false
                                this.addTemplateForm = {
                                    technologyTemplateName: '',
                                    technologyTemplateCode: '',
                                    remark: '',
                                    templateFlowVOs:[{
                                        procedureIndex:1,
                                        isNeedReport:true
                                    }],
                                }
                            
                                this.search()
                            } else {
                                this.$message.error(res.message);
                                this.search()
                            }
                        },
                    })
                }
            })
        },
        cancelAdd(){
            this.$refs['addForm'].clearValidate()
            this.addDialogVisible = false

            this.addTemplateForm = {
                technologyTemplateName: '',
                technologyTemplateCode: '',
                remark: '',
                templateFlowVOs:[{
                    procedureIndex:1,
                    isNeedReport:true,
                }],
                
            }
        },

        async loadProcedureListByWorkCenterCode(workCenterCode){
            let {data,code,message,msg} = await this.$RequestUtil.getAsync({url: "/api/procedureConfig/getProcedureNameByWorkCenterCode",params: {workCenterCode}})
            return data
        },

        async factoryChange(ev,scope){
          
            let {factoryName,factoryCode} = (this.FactoryList.find(item=>item.factoryId==ev)||{})
            let procedureNameList =  await this.loadProcedureListByWorkCenterCode(factoryCode)
            
            if(!scope.row.procedureName){
                this.$set(scope.row,'procedureName',factoryName)
            }
            this.$set(scope.row,'procedureNameList',procedureNameList)
        },
        //   工作中心远程搜索
        remoteMethod2: async function (factoryName, factoryCode) {
            await this.getListFactoryModel(factoryName, factoryCode);
        },
        
        // cs
        // 获取物料名称下拉选项
        async getMlist(materialName, materialCode) {
            let res = await this.$RequestUtil.getAsync({
                url: "/api/select/listMaterial",
                params: {
                    materialName,
                    materialCode
                }
            });
            if (res.code != 0) {
                this.$message.error(res.msg || res.message);
                return;
            }
            this.materiaList = res.data;
        },
        // 获取工作中心下拉选项
        async getListFactoryModel(Name, Code) {
            let res = await this.$RequestUtil.getAsync({
                url: "/api/select/listFactoryModel",
                params: {
                    Name,
                    Code
                }
            });
            if (res.code != 0) {
                this.$message.error(res.msg || res.message);
                return;
            }
            this.FactoryList = res.data;
        },
      
        // 新增表格
        addLists(index) {
            let lastIndex = Number(this.addTemplateForm.templateFlowVOs[index].procedureIndex)
            this.addTemplateForm.templateFlowVOs.push({ 
                procedureIndex: lastIndex + 1,
                isNeedReport:true,
                procedureMapFactoryModelList:commonUtils.cloneObj(this.procedureMapFactoryModelList)
            });
        },
        // 删除表格
        delLists(index) {
            if (this.addTemplateForm.templateFlowVOs.length == 1) {
                return this.$message.warning('不可删除！')
            } else {
                this.addTemplateForm.templateFlowVOs.splice(index, 1)
            }
        },
        // 编辑新增表格
        editAddLists(index) {
            let lastIndex = Number(this.addTemplateForm.templateFlowVOs[index].procedureIndex)
            this.addTemplateForm.templateFlowVOs.push({ 
                procedureIndex: lastIndex+1,
                isNeedReport:true,
                procedureMapFactoryModelList:commonUtils.cloneObj(this.procedureMapFactoryModelList)
            });
            // this.templateFlowVOs.push({});
        },
        // 编辑删除表格
        editDelLists(index) {
            if (this.editItemList.length == 1) {
                return this.$message.warning('不可删除！')
            } else {
                this.addTemplateForm.templateFlowVOs.splice(index, 1)
            }
        },

        // 重置表单
        resetSearch() {
            this.searchForm.technologyTemplateName = "";
            this.searchForm.technologyTemplateCode = "";
            this.searchForm.gmtCreate = [];
            this.search()
        },
        // 编辑
        editTemplate(row) {
            this.$RequestUtil.get({
                url: "/api/technologyTemplate/getTemplateMsg",
                type: "sync",
                params: {
                    technologyTemplateId: row.technologyTemplateId
                },
                success: res => {
                    if (res.code == 0) {
                       this.addTemplateForm = res.data
                       res.data.templateFlowDtos.forEach(item => {
                            // item.procedureMapFactoryModelList = commonUtils.cloneObj(this.procedureMapFactoryModelList)
                            this.$set(item,'procedureMapFactoryModelList',commonUtils.cloneObj(this.procedureMapFactoryModelList))
                       });
                    //    this.addTemplateForm.templateFlowVOs = res.data.templateFlowDtos
                       this.$set(this.addTemplateForm,'templateFlowVOs',res.data.templateFlowDtos)
                    } else {
                        this.$message.error(res.msg || res.message);
                    }
                }
            });
            this.editData = row
            this.editDialogVisible = true
        },
       
        // 查看
        seeDetail(value) {
            log(value)
            // this.seeData = value;
            this.$RequestUtil.get({
                url: "/api/technologyTemplate/getTemplateMsg",
                type: "sync",
                params: {
                    technologyTemplateId: value.technologyTemplateId
                },
                success: res => {
                    if (res.code == 0) {
                        log(res)
                        this.seeData = res.data
                        this.seeItemList = res.data.templateFlowDtos
                    } else {
                        log(res.code);
                        this.$message.error(res.msg || res.message);
                    }
                }
            });
            this.seedDialogVisible = true;
        },

        // 删除
        deleteList(rowData) {
            // log(rowData)
            let message = '此操作将删除此工艺路线模板，是否继续';
            this.$confirm(message, '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // log('delete')
                this.$RequestUtil.post({
                    url: '/api/technologyTemplate/updateTemplate',
                    type: 'sync',
                    params: {
                        isDeleted: true,
                        technologyTemplateId: rowData.technologyTemplateId,
                        // technologyTemplateCode: rowData.technologyTemplateCode
                    },
                    success: (res) => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search(this.page.pageNum)
                            // this.initTable();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.msg || res.message
                            });
                        }
                    }
                });
            });
        },
        // 编辑提交
        editSubmitList() {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let procedureIndexList = [...new Set(this.addTemplateForm.templateFlowVOs.map(item=>Number(item.procedureIndex)))]
                    if(procedureIndexList.length<this.addTemplateForm.templateFlowVOs.length){
                        this.$message.error('工序号不可重复')
                        return
                    }
                    this.$RequestUtil.post({
                        url: '/api/technologyTemplate/updateTemplate',
                        type: 'sync',
                        params: {
                            ...this.addTemplateForm
                        },
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '编辑成功!'
                                });
                                this.search(this.page.pageNum)
                                this.cancelEdit();
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.msg || res.message
                                });
                            }
                        }
                    });
                }
            })
            
        },
        cancelEdit(){
            this.$refs['editForm'].clearValidate()
            this.editDialogVisible = false
            this.addTemplateForm = {
                technologyTemplateName: '',
                technologyTemplateCode: '',
                remark: '',
                templateFlowVOs:[{procedureIndex:1,isNeedReport:true}],
                
            }
        }
    }
};
</script>

<style scoped>
</style>
<style >
@media screen and (max-width: 1366px){
    #tecnology-template .el-date-editor.el-input, #tecnology-template .el-date-editor.el-input__inner {
        width: 200px !important;
    }
}



.technolog-template-table .el-form-item .el-form-item__content{
    margin-left: 0px !important;
}
#tecnology-template .el-form-item--mini.el-form-item,#tecnology-template .el-form-item--small.el-form-item {
    margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/TechnologyBOM/TechnologyTemplate.vue